<template>
  <div class="ui ui-game">
    <GameScore />

    <footer class="ui-game__footer">
      <GameProgressbar />

      <GameLife />
    </footer>
  </div>
</template>

<script>
import GameLife from '@/components/GameLife.vue';
import GameScore from '@/components/GameScore.vue';
import GameProgressbar from '@/components/GameProgressbar.vue';

export default {
  name: 'Game',

  components: {
    GameScore,
    GameProgressbar,
    GameLife,
  },

  data() {
    return {
      muted: false,
    };
  },

  methods: {
    togglePlayPause() {
      this.$eventHub.$emit(this.$store.state.mode === 'playing' ? 'pause' : 'resume');
    },
    toggleAudio() {
      this.$eventHub.$emit(this.muted ? 'unmute' : 'mute');
      this.muted = !this.muted;
    },
  },
};
</script>

<style lang="scss" scoped>
.ui-game {
  text-align: center;
  color: $color-white;

  &__footer {
    position: fixed;
    width: 100%;
    bottom: 0;
    left: 0;

    padding: 20px;

    display: flex;
    align-items: center;
    justify-content: space-between;

    @include mq(ipadP) {
      padding: 30px;
    }

    @include mq(dm) {
      padding: 40px;
    }
  }
}
</style>
